import { render } from "./BaseFormField.vue?vue&type=template&id=24fb616b&scoped=true&ts=true"
import script from "./BaseFormField.vue?vue&type=script&lang=ts"
export * from "./BaseFormField.vue?vue&type=script&lang=ts"

import "./BaseFormField.vue?vue&type=style&index=0&id=24fb616b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fb616b"]])

export default __exports__